import styled from '@emotion/styled';
import { screenXsMax } from '@spotify-internal/encore-web';

export const StyledLanguageSelectorContainer = styled.div`
  height: 100%;
`;

export const StyledLanguageSelectorDisplay = styled.div`
  display: inline-grid;
  grid-auto-flow: column;
  grid-gap: 6px;
  align-items: center;
  width: auto;
  height: 100%;
  cursor: pointer;

  &.opened,
  &:hover {
    svg > path {
      fill: #ffffff;
    }

    span {
      color: #ffffff;
    }

    .selector-caret {
      border-top-color: #ffffff;
    }
  }

  svg {
    width: 14px;
    height: 14px;

    path {
      fill: rgba(255, 255, 255, 0.8);
    }
  }

  span {
    color: rgba(255, 255, 255, 0.8);
    font-weight: bold;
    font-size: 1rem;
    line-height: 0.75rem;
    text-transform: uppercase;
    opacity: 1;
  }

  .selector-caret {
    display: inline-block;
    width: 0;
    height: 0;
    margin-top: 3px;
    border: 6px solid transparent;
    border-top-color: rgba(255, 255, 255, 0.8);
    border-right-color: transparent;
    border-bottom-width: 0;
    border-left-color: transparent;
  }
`;

export const StyledLanguageSelectorListContainer = styled.div<{
  isDesktop?: boolean;
}>`
  position: ${({ isDesktop }) => (isDesktop ? 'relative' : 'absolute')};
  top: 0;
  height: 100%;
`;

export const StyledLanguageSelectorList = styled.ul<{ isDesktop?: boolean }>`
  position: absolute;
  padding: 6px;
  border: 2px solid #dedfe0;
  border-radius: 6px;
  background: #f2f2f3;
  z-index: 100;
  height: ${({ isDesktop }) => (isDesktop ? 'auto' : '100%')};
  overflow: scroll;
  ${({ isDesktop }) => (isDesktop ? 'right: 0' : 'left: 0')};

  li {
    margin: 0;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
`;

export const StyledLanguageSelectorListItem = styled.li<{
  isSelected?: boolean;
}>`
  list-style: none;
  padding: 0px 6px 1px 14px;
  font-weight: ${({ isSelected }) => (isSelected ? 'bold' : 'normal')};
  cursor: pointer;
  position: relative;
  white-space: nowrap;

  &:hover {
    color: #fff;
    background: #4c8bf5;
  }

  ${({ isSelected }) =>
    isSelected
      ? `
      pointer-events: none;
      &::before {
        content: "\\2713";
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    `
      : ''}
`;

// TODO: https://anchorfm.atlassian.net/browse/CAST-2581: Remove all PSC Styled Components when we remove the PSCStyledLanguageSelector
// and switch to using the StyledLanguageSelector in the navbar for all pages
export const PSCStyledLanguageSelectorContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;

  @media screen and (max-width: ${screenXsMax}px) {
    top: 20px;
    right: 20px;
  }
`;

export const PSCStyledLanguageSelectorDisplay = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: auto;
  min-width: 80px;
  height: 20px;
  cursor: pointer;

  svg[aria-labelledby*='globeIcon'] {
    width: 14px;
    height: 14px;
    margin-right: 4px;

    path {
      fill: rgb(95, 99, 105);
    }
  }

  svg:not([aria-labelledby*='globeIcon']) {
    width: 10px;
    height: 10px;
    opacity: 0.7;
    stroke: #292f36;
  }

  span {
    margin-right: 4px;
    color: #292f36;
    font-size: 0.875rem;
    line-height: 1.25rem;
    text-transform: uppercase;
    opacity: 0.7;
  }
`;

export const PSCStyledLanguageSelectorListContainer = styled.div`
  position: relative;
`;

export const PSCStyledLanguageSelectorList = styled.ul`
  position: absolute;
  right: 0;
  padding: 6px;
  border: 2px solid #dedfe0;
  border-radius: 6px;
  background: #f2f2f3;
  z-index: 1;

  li {
    margin: 0;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
`;

export const PSCStyledLanguageSelectorListItem = styled.li<{
  isSelected?: boolean;
}>`
  list-style: none;
  padding: 0px 6px 1px 14px;
  font-weight: ${({ isSelected }) => (isSelected ? 'bold' : 'normal')};
  cursor: pointer;
  position: relative;
  white-space: nowrap;

  &:hover {
    color: #fff;
    background: #4c8bf5;
  }

  ${({ isSelected }) =>
    isSelected
      ? `
      pointer-events: none;
      &::before {
        content: "\\2713";
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    `
      : ''}
`;
